// /bonos/cancelled — landing si el alumno cancela el checkout Stripe o si
// éste expira. No se crea ningún bono en BD (Stripe no llega a cobrar).

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';

export default function BonoCompraCancelled() {
  const { t } = useTranslation();

  return (
    <main className="bono-result-page">
      <div className="bono-result bono-result--cancelled">
        <div className="bono-result-icono"><AlertCircle size={36} strokeWidth={2} /></div>
        <h1 className="bono-result-titulo">{t('bono_result.cancelled_titulo')}</h1>
        <p className="bono-result-texto">{t('bono_result.cancelled_texto')}</p>
        <div className="bono-result-acciones">
          <Link to="/mis-bonos" className="btn-primary">{t('bono_result.btn_volver')}</Link>
          <Link to="/horarios" className="btn-ghost">{t('bono_result.btn_ver_horarios')}</Link>
        </div>
      </div>
    </main>
  );
}
